'use client'

import Link from 'next/link'
import { Image } from '../image/image'
import s from './banner-card.module.css'
import { useBreakpoint } from '@/hooks/use-breakpoint'
import { SLIDER_CLASS_NAME } from '@/constants'
import cx from 'classnames'
import { useState } from 'react'

type Props = {
  title: string
  buttonText: string
  buttonLink: string
  imageUrl: string
  imageAlt?: string
  adjustToSlider?: boolean
}

export const BannerCard = ({
  title,
  buttonLink,
  buttonText,
  imageUrl,
  imageAlt,
  adjustToSlider,
}: Props) => {
  const breakpoint = useBreakpoint()
  const isMobileOrTablet = breakpoint === 'mobile' || breakpoint === 'tablet'
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div className={cx({ [SLIDER_CLASS_NAME]: adjustToSlider }, s.container)}>
      <Image
        src={imageUrl}
        alt={imageAlt || 'banner card image'}
        width={isMobileOrTablet ? 270 : 429}
        height={isMobileOrTablet ? 364 : 502}
        fill
        className={s.image}
      />
      <div
        className={cx(s.shadowHover, {
          [s.shadowHoverActive]: isHovered && !isMobileOrTablet,
        })}
      ></div>
      <div className={s.content}>
        <p className={s.cardTitle}>{title}</p>
        <Link
          className={s.button}
          href={buttonLink}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {buttonText}
        </Link>
      </div>
    </div>
  )
}
